import { createEnv } from "@t3-oss/env-nextjs";
import { z } from "zod";

const env = createEnv({
  server: {
    NEXT_PREVIEW_TOKEN: z.string(),
    CENTRA_CHECKOUT_SECRET: z.string(),
    CENTRA_INTEGRATION_TOKEN: z.string(),
    STORYBLOK_TOKEN: z.string().min(1),
    CENTRA_INTEGRATION_URL: z.string().url(),
    DEDUPE_SECRET: z.string().min(1),
    CENTRA_DOMAIN: z.string().min(1),
    REVALIDATE_SECRET: z.string().min(1),
    NEXT_PUBLIC_KLAVIYO_ACCOUNT_ID: z.string().min(1),
  },
  client: {
    NEXT_PUBLIC_CENTRA_CHECKOUT: z.string(),
    NEXT_PUBLIC_ENV: z.string(),
    NEXT_PUBLIC_STREAM_URL: z.string().url(),
    NEXT_PUBLIC_DEDUPE_URL: z.string().min(1),
    NEXT_PUBLIC_CENTRA_DOMAIN: z.string().min(1),
    NEXT_PUBLIC_GTM_ID: z.string().min(1),
    NEXT_PUBLIC_HYPERDX_KEY: z.string().min(1),
    NEXT_PUBLIC_DEPICT_MERCHANT: z.string().min(1),
    NEXT_PUBLIC_KLAVIYO_ACCOUNT_ID: z.string().min(1),
  },
  runtimeEnv: {
    NEXT_PUBLIC_DEPICT_MERCHANT: process.env.NEXT_PUBLIC_DEPICT_MERCHANT,
    NEXT_PREVIEW_TOKEN: process.env.NEXT_PREVIEW_TOKEN,
    CENTRA_CHECKOUT_SECRET: process.env.CENTRA_CHECKOUT_SECRET,
    NEXT_PUBLIC_GTM_ID: process.env.NEXT_PUBLIC_GTM_ID,
    CENTRA_INTEGRATION_TOKEN: process.env.CENTRA_INTEGRATION_TOKEN,
    CENTRA_INTEGRATION_URL: process.env.CENTRA_INTEGRATION_URL,

    NEXT_PUBLIC_CENTRA_CHECKOUT: process.env.NEXT_PUBLIC_CENTRA_CHECKOUT,
    NEXT_PUBLIC_ENV: process.env.NODE_ENV,
    NEXT_PUBLIC_STREAM_URL: process.env.NEXT_PUBLIC_STREAM_URL,
    STORYBLOK_TOKEN: process.env.STORYBLOK_TOKEN,
    DEDUPE_SECRET: process.env.DEDUPE_SECRET,
    NEXT_PUBLIC_DEDUPE_URL: process.env.NEXT_PUBLIC_DEDUPE_URL,
    CENTRA_DOMAIN: process.env.CENTRA_DOMAIN,
    NEXT_PUBLIC_CENTRA_DOMAIN: process.env.NEXT_PUBLIC_CENTRA_DOMAIN,
    REVALIDATE_SECRET: process.env.REVALIDATE_SECRET,
    NEXT_PUBLIC_HYPERDX_KEY: process.env.NEXT_PUBLIC_HYPERDX_API_KEY,
    NEXT_PUBLIC_KLAVIYO_ACCOUNT_ID: process.env.NEXT_PUBLIC_KLAVIYO_ACCOUNT_ID,
  },
});

export default env;
